import { Image as ImageIcon } from "lucide-react";

import { FrameSlot, type Frame } from "./FrameSlot";
import { SoonSlot } from "./SoonSlot";

/**
 * The start frame: the image the video starts from. Without `start` (the catalog offers no video
 * from an image) the slot is Coming soon.
 */
export function StartFrameSlot({ start }: { start: Frame | undefined }) {
  if (start === undefined) {
    return <SoonSlot label="Start frame" icon={<ImageIcon size={20} strokeWidth={1.5} />} />;
  }
  return <FrameSlot label="Start frame" frame={start} />;
}
